// import { EmployeeList } from "components/Employee";

import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { EmployeeList } from "../../components/EmployeeList";
import { FC } from "react";
import { PayrollHolidayEarningList } from "../../components/PayrollHolidayEarningList/PayrollHolidayEarningList";

export interface IPayrollHolidayEarningsListPage {}

export const PayrollHolidayEarningsListPage: FC<IPayrollHolidayEarningsListPage> = (
  props: IPayrollHolidayEarningsListPage
) => {
  return (
    <AuthenticatedLayout
      pageTitle="Payroll Holiday Earning"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "", navigateTo: "/payroll-federal-earning/list" },
      ]}
      mainContents={<PayrollHolidayEarningList />}
    />
  );
};
